/**
 * Created by XuDL(Wisea) on 2017/06/03
 */
;
(function(window, $, undefined) {

	"use strict";

	$.extend({
		// 同步锁(锁对象，锁表达式)
		syncLock : function(options) {
			var opt = $.extend({}, $.syncLock.defaults, options);
			// 表达式和回调不能为空
			if(opt.express && opt.callBack && $.isFunction(opt.express) && $.isFunction(opt.callBack)){
				var reTryMax = opt.maxItera;
				var retry = 0;
				// 校验表达式 表达式为真加载停止
				if(!opt.express()){
					var intVel = null;
					intVel = setInterval(function(){
						// 超过等待次数停止
						if(reTryMax >= 0 && retry >= reTryMax){
							clearInterval(intVel);
							return;
						}
						// 校验表达式 表达式为真加载停止
						if(opt.express()){
							clearInterval(intVel);
							// 回调
							opt.callBack();
						}
						retry++;
					}, opt.flush);
				} else {
					// 回调
					opt.callBack();
				}
			}
		}
	});
	
	// express表达式函数，callBack回调函数，flush刷新频率，maxItera 迭代次数
	$.syncLock.defaults = {
		"flush" : 500,
		"maxItera" : 6
	};
})(window, window.jQuery);



//////////////////
// WEBPACK FOOTER
// ./static/js/syncLock.js
// module id = lJpB
// module chunks = 11